<div class="company-container">
  <div class="top-part">
    <div class="top-part-wrap">
      <div class="first-section">
        <div class="dept-navbar me-5">
          <button
            class="nav-link d-flex align-items-center"
            [class.active]="isButtonActive == true"
            (click)="activeTab(true)"
          >
            Active Stations
          </button>
          <button
            class="nav-link"
            [class.active]="isButtonActive == false"
            (click)="activeTab(false)"
          >
            Inactive Stations
          </button>
        </div>
      </div>
      <div class="second-section d-flex align-items-center justify-content-end">
        <span matTooltip="Delete Record(s)" matTooltipPosition="above">
          <button
            class="btn filter-btn ms-2"
            *ngIf="isButtonActive"
            data-toggle="modal"
            data-backdrop="static"
            data-target="#deleteDataModal"
            (click)="openConfirmPopup(selectedStationIds)"
          >
            <img
              style="width: 22px"
              src="../../../assets/Pricingscreen/delete.svg"
            />
          </button>
        </span>
        <span matTooltip="Export Data" matTooltipPosition="above">
          <button class="btn filter-btn ms-2" (click)="exportToExcel()">
            <img
              style="width: 22px"
              src="../../../assets/Pricingscreen/export.svg"
            />
          </button>
        </span>
        <span matTooltip="Filter Data" matTooltipPosition="above">
          <button
            class="filter-btn ms-2"
            data-bs-target="#filterData"
            data-bs-toggle="modal"
            (click)="openFilterModal('Open')"
          >
            <i
              ><img
                style="width: 25px"
                src="../../../assets/Pricingscreen/filter.svg"
            /></i>
          </button>
        </span>
        <div class="searchbar d-flex ms-2">
          <img class="search me-2" src="../../../assets/icons/searchbar.svg" />
          <input
            type="text"
            placeholder="Search station"
            [(ngModel)]="enteredStation"
            (keyup)="search($event)"
          />
        </div>
        <ng-template [ngxPermissionsOnly]="['Station:Create']">
          <div
            class="create-btn add-btn mx-2 c-pt"
            data-bs-target="#addStationModalToggle"
            data-bs-toggle="modal"
            (click)="createNew()"
          >
            <img src="../../../../../assets/icons/whitePlus.svg" />
            Add New
          </div>
        </ng-template>

        <div class="dropdown custom-left ms-2">
          <button
            class="btn dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            id="removeContent"
            matTooltip="More Options"
            matTooltipPosition="above"
            matTooltipClass="raised-tooltip"
          >
            <img src="../../../../assets/Pos-Catalog/importdots.svg" />
          </button>
          <div class="dropdown-menu" id="firstDropdown">
            <div class="first-part">
              <ul class="dropdown-list list-unstyled mb-0">
                <li>
                  <a class="dropdown-item" (click)="DownloadStationTemplate()"
                    ><img
                      class="me-3"
                      src="../../../../assets/Pos-Catalog/arrowDown.svg"
                    />Download Template</a
                  >
                </li>
                <li>
                  <a class="dropdown-item" (click)="importStations()"
                    ><img
                      class="me-3"
                      src="../../../../assets/Pos-Catalog/arrowDown.svg"
                    />Import Stations</a
                  >
                </li>
                <li *ngIf="isButtonActive">
                  <a class="dropdown-item" (click)="exportToExcel()"
                    ><img
                      class="me-3"
                      src="../../../../assets/Pos-Catalog/arrowup.svg"
                    />Export Stations</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <section class="intro">
    <div class="table-container">
      <table class="table category-table table-condensed">
        <thead class="main-head sticky-top">
          <tr>
            <th scope="col" style="align-items: center; text-transform: none">
              <div class="form-check d-flex align-items-center">
                <input
                  style="height: 20px; width: 20px; margin-right: 10px"
                  class="form-check-input"
                  id="flexCheckDefault1"
                  type="checkbox"
                  [checked]="headerCheckboxSelected"
                  (change)="toggleAllCheckboxes()"
                  *ngIf="isButtonActive"
                />
                <label for="flexCheckDefault">
                  Name
                  <img
                    style="margin: 0 0 2px 1px; cursor: pointer"
                    src="../../../assets/Pricingscreen/sorting_val.svg"
                    (click)="sortValues('stationName')"
                  />
                </label>
              </div>
            </th>
            <th scope="col" style="text-transform: none">
              Store
              <img
                style="margin: 0 0 2px 1px; cursor: pointer"
                src="../../../assets/Pricingscreen/sorting_val.svg"
                (click)="sortValues('StoreName')"
              />&nbsp;
              <i
                class="fa-regular fa-circle-xmark text-danger"
                (click)="clearFilter('store')"
                *ngIf="filterGoalIds.length > 0"
              ></i>
            </th>
            <th
              scope="col"
              style="text-transform: none"
              *ngIf="isButtonActive == true"
            >
              License Status
            </th>
            <th
              scope="col"
              style="text-transform: none"
              *ngIf="isButtonActive == true"
            >
              Active User
            </th>
            <th scope="col" style="text-transform: none">Created On</th>
            <th scope="col" style="text-transform: none">Created By</th>
            <th scope="col" style="text-transform: none" class="text-end pe-5">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let station of StationsArray"
            [ngClass]="{
              'highlighted-row': station.stationId === selectedRowIndex
            }"
          >
            <td class="d-flex g-2" colspan="2" style="align-items: center">
              <div class="form-check d-flex align-items-center">
                <input
                  style="height: 20px; width: 20px; margin-right: 10px"
                  class="form-check-input"
                  type="checkbox"
                  [value]="station.stationId"
                  id="flexCheckDefault1"
                  [checked]="headerCheckboxSelected"
                  [(ngModel)]="station.sIsSelected"
                  (change)="handleCheckboxChange($event, station.stationId)"
                  *ngIf="isButtonActive"
                />
              </div>
              <label for="" style="font-size: 14px; font-weight: 700">{{
                station.stationName
              }}</label>
            </td>
            <td>{{ station.storeName }}</td>
            <td *ngIf="isButtonActive == true">{{ station.statusText }}</td>
            <td *ngIf="isButtonActive == true">
              {{
                station.currentlyAssignedToUsername
                  ? station.currentlyAssignedToUsername
                  : "-"
              }}
            </td>
            <td>{{ station.createdDt | date : "MM/dd/yyyy" }}</td>
            <td>{{ station.createdByUser }}</td>
            <td class="text-end pe-5">
              <div class="btn-group dropleft">
                <span matTooltip="End Session" matTooltipPosition="above">
                  <button
                    type="button"
                    class="action-drop me-2"
                    *ngIf="station.currentlyAssignedToUsername"
                    (click)="unassignLicense(station)"
                  >
                    <i
                      class="fa-solid fa-right-from-bracket mt-1"
                      style="color: #676767; font-size: 20px"
                      data-bs-toggle="modal"
                      data-bs-target="#endSessionModal"
                    ></i>
                  </button>
                </span>
                <ng-template [ngxPermissionsOnly]="['Station:Update']">
                  <span matTooltip="Edit Record" matTooltipPosition="above">
                    <button
                      type="button"
                      class="action-drop me-2"
                      data-bs-target="#addStationModalToggle"
                      data-bs-toggle="modal"
                      (click)="getStationByIdforUpdate(station)"
                    >
                      <i
                        ><img
                          width="25"
                          src="../../../assets/Pricingscreen/update.svg"
                      /></i>
                    </button>
                  </span>
                </ng-template>
                <!-- <ng-template *ngIf="isButtonActive == true" [ngxPermissionsOnly]="['Station:Delete']">
                  <button type="button" class="action-drop" data-toggle="modal" data-backdrop="static"
                    data-target="#deleteDataModal" (click)="openConfirmPopup(station.stationID)">
                    <i><img width="20" src="../../../assets/Pricingscreen/delete.svg" /></i>
                  </button>
                </ng-template> -->
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div
        *ngIf="isLoading"
        class="d-flex justify-content-center align-items-center"
        style="height: 56vh; width: 100%"
      >
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div
        *ngIf="!isLoading && StationsArray.length == 0"
        class="nodata"
        style="
          height: 56vh;
          width: 100%;
          display: flex;
          margin: auto;
          align-items: center;
          margin: auto;
          border: none;
        "
      >
        <p
          style="
            margin: auto;
            border: transparent !important;
            font-size: 2rem;
            color: #a4a4a4;
          "
        >
          No Data Available
        </p>
      </div>
    </div>
  </section>
</div>

<!--Boostrap modal for filter data-->
<div
  class="modal fade"
  id="filterData"
  aria-hidden="true"
  aria-labelledby="exampleModalToggleLabel"
  data-bs-backdrop="static"
  tabindex="-1"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="mb-0">Filters</h5>
      </div>
      <div class="modal-body p-0">
        <div class="filter d-flex">
          <div class="filter-labels">
            <h6 class="ps-4">Lists</h6>
            <div class="filter-labels-wrapper">
              <ul class="list-unstyled">
                <li
                  (click)="selectedFilterCategory('store')"
                  [ngClass]="{ active: filterName === 'store' }"
                >
                  Store
                  <br />
                  <p *ngIf="filterGoalIds.length > 0">
                    {{ filterGoalIds.length }} selected
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div class="filter-data">
            <h6 class="ps-2">Selected by: {{ filterName }}</h6>
            <div class="filter-data-wrapper">
              <div class="row" *ngIf="filterName == 'store'">
                <div
                  class="col-lg-3 col-sm-6"
                  *ngFor="let data of ArrayForStations; let idx = index"
                >
                  <div
                    class="conntent-box"
                    [ngClass]="{ active: data.isSelected == true }"
                    (click)="collectFilterParameters(data.storeId)"
                  >
                    <!--<i><img class="filtericon" [src]="data.dImageIcon" /></i>-->
                    <span
                      class="mt-2 text-center"
                      style="font-size: 13px; color: black"
                      >{{ data.storeName }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-end">
        <div class="footer-wrapper">
          <button
            class="btn modal-btn me-2"
            data-bs-dismiss="modal"
            aria-label="Close"
            style="background-color: #ffffff; color: #0070b9"
            (click)="openFilterModal('Close')"
          >
            Cancel
          </button>
          <button
            class="btn modal-btn me-2"
            data-bs-dismiss="modal"
            aria-label="Close"
            style="background-color: #0070b9; color: white"
            (click)="getFilterData()"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Boostrap modal for add new station -->
<div
  class="modal fade"
  id="addStationModalToggle"
  aria-hidden="true"
  aria-labelledby="exampleModalToggleLabel"
  tabindex="-1"
>
  <div class="custom-modal-dialog modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="custom-modal-header modal-header">
        <h5 class="mb-0">{{ frmText }}</h5>
      </div>
      <div class="custom-modal-body modal-body">
        <div class="modal-body-wraapper">
          <div class="selector">
            <div class="custom-label">
              <label for="stationNameInput" class="form-label"
                >Station Name:</label
              >
              <p>:</p>
            </div>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="stationsData.stationName"
              id="stationNameInput"
              placeholder="Enter station name"
            />
          </div>
          <div class="selector">
            <div class="custom-label">
              <label for="">Store Name</label>
              <p>:</p>
            </div>
            <select
              class="custom-form-select form-select"
              aria-label="Default select example"
              [(ngModel)]="stationsData.storeId"
            >
              <option value="0" hidden>Select</option>
              <option *ngFor="let store of stores" [ngValue]="store.storeId">
                {{ store.storeName }}
              </option>
            </select>
          </div>
          <!--Radio nbuttons for status-->
          <div class="d-flex align-items-center justify-content-between">
            <div class="custom-label">
              <span style="margin-left: 17px">Status</span>
              <p>:</p>
            </div>
            <div class="get-status">
              <div class="form-check me-5">
                <input
                  class="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="active"
                  [(ngModel)]="stationsData.active"
                  [value]="true"
                />
                <label class="form-check-label" for="active"> Active </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="inactive"
                  [(ngModel)]="stationsData.active"
                  [value]="false"
                />
                <label class="form-check-label" for="inactive">
                  Inactive
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="custom-modal-footer modal-footer mt-4">
        <button
          class="btn modal-btn me-2"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          Cancel
        </button>
        <button
          class="modal-btn disable-btn me-2"
          [hidden]="stationsData.stationName && stationsData.storeId > 0"
        >
          Add Station
        </button>
        <div
          class="btn modal-btn add-btn me-2"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="addstation(stationsData)"
          style="width: auto"
          [hidden]="
            !(
              stationsData.stationName &&
              stationsData.storeId > 0 &&
              frmText == 'Add New Station'
            )
          "
        >
          Add Station
        </div>
        <div
          class="btn modal-btn add-btn me-2"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="addstation(stationsData)"
          [hidden]="
            !(
              stationsData.stationName &&
              stationsData.storeId > 0 &&
              frmText == 'Update Station'
            )
          "
        >
          Update
        </div>
      </div>
    </div>
  </div>
</div>

<!--Boostrap modal for deleting Station -->
<div
  class="modal fade"
  id="deleteDataModal"
  aria-hidden="true"
  aria-labelledby="exampleModalToggleLabel"
  tabindex="-1"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" *ngIf="deleteButtonClickedWithSelection">
        <h5>Delete</h5>
      </div>
      <div class="modal-header" *ngIf="deleteButtonClickedWithoutSelection">
        <h5>No Record Selected !</h5>
      </div>

      <div class="modal-body" *ngIf="deleteButtonClickedWithSelection">
        <div class="modal-body-wraapper">
          <p>
            Are you sure you want to delete the station “{{
              stationName
            }}”?<br />
            Or you can make “{{ stationName }}” inactive.
          </p>
          <p class="fw-bold mt-3">
            Once deleted, all the saved data will get deleted.
          </p>
        </div>
      </div>
      <div class="modal-body" *ngIf="deleteButtonClickedWithoutSelection">
        <div class="modal-body-wraapper">
          <p>Please select one or more records to delete.</p>
        </div>
      </div>
      <div class="custom-modal-footer modal-footer">
        <button
          class="btn modal-btn me-2"
          data-dismiss="modal"
          aria-label="Close"
        >
          Close
        </button>
        <button
          button
          class="btn modal-btn"
          data-dismiss="modal"
          aria-label="Close"
          *ngIf="deleteButtonClickedWithSelection"
          style="background-color: rgb(23, 95, 145); color: white"
          (click)="deleteStation(deleteParameter)"
        >
          Yes, Delete
        </button>
      </div>
    </div>
  </div>
</div>

<!--Boostrap modal for ending user session -->
<div
  class="modal fade"
  id="endSessionModal"
  aria-hidden="true"
  aria-labelledby="exampleModalToggleLabel"
  tabindex="-1"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="mb-0">Confirm Session End</h5>
      </div>
      <div class="modal-body pt-1">
        <div class="modal-body-wraapper">
          <p>
            Are you sure you want to end the session for user
            {{ stationObjToEndSession.userName }}? Ending the session will log
            out {{ stationObjToEndSession.userName }} from the system.
          </p>
        </div>
      </div>
      <div class="custom-modal-footer modal-footer">
        <button
          class="btn modal-btn me-2 w-auto"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          Close
        </button>
        <button
          button
          class="btn modal-btn w-auto"
          data-bs-dismiss="modal"
          aria-label="Close"
          style="background-color: #0070b9; color: white"
          (click)="endUserSession()"
        >
          End Session
        </button>
      </div>
    </div>
  </div>
</div>

<input
  class="d-none"
  #importStation
  type="file"
  accept=".xlsx, .xls, .csv"
  (change)="onFileChangeImport($event)"
/>
<!-- Button trigger modal -->
<button
  #importModel
  type="button"
  class="btn btn-primary d-none"
  data-bs-toggle="modal"
  data-bs-target="#addbulkuserModal"
></button>
<!-- Modal -->
<div
  class="modal fade"
  id="addbulkuserModal"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
  data-bs-backdrop="static"
>
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-scrollable custom-modal-dialog"
    style="max-width: 50%"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="addbulkuserModalLabel">Import Stores</h5>

        <button
          type="button"
          class="btn-close"
          data-bs-toggle="modal"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="closeImportModal()"
        ></button>
      </div>
      <div class="modal-body">
        <div class="tbl-container">
          <table class="table">
            <thead class="sticky-top">
              <tr>
                <th
                  scope="col"
                  style="display: flex; align-items: center; gap: 7px"
                >
                  <input
                    [(ngModel)]="toggleAll"
                    [disabled]="isImportDisabled"
                    type="checkbox"
                    class="form-check-input formMaster mod m-0"
                    (click)="checkAllImport($event)"
                  />
                  Station Name
                </th>
                <th scope="col">Store Name</th>
                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let station of importStationList; let i = index">
                <td style="display: flex; align-items: center; gap: 7px">
                  <input
                    (click)="isImportEnabled()"
                    [disabled]="station.status == 1 || station.status == 0"
                    type="checkbox"
                    class="form-check-input formItem mod m-0"
                    [(ngModel)]="station.isChecked"
                  />
                  <ng-container *ngIf="station.stationName != null">
                    {{ station.stationName }}
                  </ng-container>
                </td>
                <td>{{ station.storeName }}</td>
                <td
                  class="tooltip-container"
                  style="display: flex; align-items: center; gap: 6px"
                  [ngStyle]="{
                    color:
                      station.status === null
                        ? '#FFCA28'
                        : station.status === true
                        ? '#66BB6A'
                        : '#EF5350'
                  }"
                >
                  <img
                    *ngIf="station.status != null"
                    img
                    [src]="
                      station.status === false
                        ? '../../../../assets/products-imgs/redError.svg'
                        : station.status === true
                        ? '../../../../assets/products-imgs/greenCheck.svg'
                        : ''
                    "
                    alt="Status Image"
                    style="width: 25px; height: 25px; object-fit: contain"
                  />
                  <ng-container class="tooltip-button">
                    <ng-container *ngIf="station.status === null">
                      Not added to database
                    </ng-container>
                    <ng-container *ngIf="station.status === true">
                      {{
                        station.reason[0] == "New station created"
                          ? "Added to database"
                          : station.reason[0] == "Existing station updated"
                          ? "Existing Station updated"
                          : ""
                      }}
                    </ng-container>
                    <ng-container *ngIf="station.status === false">
                      <!-- Show first error -->
                      {{ station.reason[0].split("|")[0] }}

                      <!-- Show +count if more errors exist -->
                      <span
                        *ngIf="station.reason[0].split('|').length > 1"
                        class="error-count-tooltip"
                        [matTooltip]="getRemainingErrors(station.reason[0])"
                        matTooltipClass="error-tooltip"
                      >
                        +{{ station.reason[0].split("|").length - 1 }}
                      </span>
                    </ng-container>
                  </ng-container>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <button
          [disabled]="isImportDisabled"
          class="btn"
          (click)="addImportedStations()"
          style="
            background-color: #0070b9;
            color: white;
            display: flex;
            align-items: center;
            gap: 6px;
          "
        >
          <img src="../../../../assets/products-imgs/downloadIcon.svg" /> Import
          selected Store(s)
        </button>
      </div>
    </div>
  </div>
</div>
